import { reactive, computed, watchEffect, onBeforeUnmount } from 'vue'

// Registro compartilhado do estado das sincronizações do header (pregões e alertas por portal).
// Cada motor (syncpregoes, syncalertas, syncalertasbnc) continua independente: só PUBLICA aqui
// o que está acontecendo, e o card único do header (StatusSyncPortais) lê e exibe em tempo real.

// id -> { id, label, ordem, estado, detalhe, segundos, rotuloSegundos, ultimaEm, ultimoResultado, erroEm }
// estado: 'erro' | 'rodando' | 'ocioso' | 'fora'
const itens = reactive({})

export function publicarSync(id, dados) {
  itens[id] = { id, ...dados }
}

export function removerSync(id) {
  delete itens[id]
}

// Usado pelos motores: `fonte` é uma função que devolve o estado atual; roda dentro de um
// watchEffect, então qualquer ref lida ali (countdown, statusMsg...) republica sozinho.
export function usePublicarSync(id, fonte) {
  watchEffect(() => publicarSync(id, fonte()))
  onBeforeUnmount(() => removerSync(id))
}

// Prioridade: falha pendente > rodando > fora da janela > ocioso (aguardando a próxima execução).
// `concluido` = os 5 segundos em que o motor mostra o resultado da execução que acabou de terminar.
export function calcularEstadoSync({ erroMsg, running, concluido, dentroJanela }) {
  if (erroMsg) return 'erro'
  if (running && !concluido) return 'rodando'
  if (running && concluido) return 'ocioso'
  return dentroJanela ? 'ocioso' : 'fora'
}

export function useSyncStatus() {
  const lista = computed(() => Object.values(itens).sort((a, b) => (a.ordem ?? 99) - (b.ordem ?? 99)))
  return { lista }
}
